<template>
    <div>
        <div class="mb-4 pb-md-2">
            <div class="row gx-2">
                <div class="col-md-8 col-lg-auto">
                    <div class="card border-0 pr-lg-5">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-auto mr-4">
                                    <div class="text-uppercase text-primary font-weight-bold mb-2">
                                        Je recherche
                                    </div>
                                </div>
                                <div class="col-md">
                                    <div class="row gy-3">
                                        <div class="col-auto mr-md-4">
                                            <CategoryFilter
                                                :criterias="criterias"
                                                :value="value"
                                                @input="handleChanged"
                                            />
                                        </div>
                                        <div class="col-auto">
                                            <QualiopiFilter
                                                :criterias="criterias"
                                                :value="value"
                                                @input="handleChanged"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col d-none d-sm-block mt-n2 mt-md-0">
                    <div class="card h-100 border-0">
                        <div class="card-body pt-0 pt-md-4 pl-xl-5">
                            <a class="d-block text-uppercase font-weight-bold course-list__images-link" :href="baseUrl('/cursus/images')" target="_blank" style="line-height: 1.3">
                                <div class="mb-2">
                                    <Icon class="d-block course-list__images-icon" name="cursus" width="50" height="25" />
                                </div>
                                Galerie photos
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <DateFilter
            :criterias="criterias"
            :value="value"
            @input="handleChanged"
        />
    </div>
</template>

<script>
  import { BTab, BTabs } from 'bootstrap-vue';
  import Icon from "../../ui/Icon.vue";
  import CategoryFilter from "../../filters/CategoryFilter.vue";
  import DateFilter from "../../filters/DateFilter.vue";
  import { baseUrl } from "../../../util/config";
  import QualiopiFilter from "../../filters/QualiopiFilter.vue";

  export default {
        components: {
            QualiopiFilter,
            DateFilter,
            CategoryFilter,
            Icon,
            BTab,
            BTabs,
        },
        props: {
            criterias: Object,
            value: Object,
        },
        methods: {
            baseUrl,
            handleChanged(value) {
                this.$emit('input', {
                    ...value,
                });
            },
        }
    }
</script>
